var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exclamation-linear-gradient",
    x1: 0.295,
    y1: 0.74,
    x2: 1.024,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd4081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523e83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(-1310 -405)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1316 407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-alert",
    "data-name": "Icon ionic-ios-alert",
    d: "M15.375,3.375a12,12,0,1,0,12,12A12,12,0,0,0,15.375,3.375ZM16.367,9.7l-.179,6.64a.826.826,0,0,1-.813.854h0a.826.826,0,0,1-.813-.854L14.383,9.7a.994.994,0,0,1,.992-1.015h0A.994.994,0,0,1,16.367,9.7Zm-.992,11.331a1.062,1.062,0,1,1,1.1-1.062A1.072,1.072,0,0,1,15.375,21.029Z",
    transform: "translate(1306.625 401.625)",
    fill: "url(#exclamation-linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.7cc996edc7faa9cd107b7219bd7622c9.svg";
export { ForwardRef as ReactComponent };